import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import { PaginationQueryDto } from '../../../../types/paginationRequestType';
import {
  getContinuousEducationSectionsActionRequest,
  getContinuousEducationSectionsFormActionRequest,
} from '../api';
import { ContinuousEducationSectionFilters } from '../types';

const getContinuousEducationSectionsAction = actionKitImpFunction(
  async (params: PaginationQueryDto<ContinuousEducationSectionFilters>) => {
    const response = await getContinuousEducationSectionsActionRequest(params);
    if (response.error) {
      throw new Error('Error fetching paginated data');
    }

    const { data } = response;

    return data;
  },
);

const getContinuousEducationSectionsFiltersFormAction = actionKitImpFunction(
  async () => {
    const response = await getContinuousEducationSectionsFormActionRequest();
    if (response.error) {
      throw new Error('Error fetching form data');
    }

    const { data } = response;

    return data;
  },
);

export {
  getContinuousEducationSectionsAction,
  getContinuousEducationSectionsFiltersFormAction,
};
